import { ActionIcon, Group, Text } from '@cowbell/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import styles from './FindingsPanel.module.css';

interface FindingsPanelProps {
  readonly isOpen: boolean;
  readonly onClose: () => void;
  readonly children: React.ReactNode;
  readonly width?: number;
  readonly chatWidth?: number;
  readonly chatRight?: number;
  readonly accountName?: string;
}

export default function FindingsPanel({
  isOpen,
  onClose,
  children,
  width = 480,
  chatWidth,
  chatRight = 0,
  accountName,
}: Readonly<FindingsPanelProps>) {
  if (!isOpen) return null;

  const rightOffset =
    chatWidth === undefined ? undefined : chatWidth + chatRight;
  const panelClassName =
    rightOffset === undefined
      ? styles.panel
      : `${styles.panel} ${styles.docked}`;

  return (
    <div
      className={panelClassName}
      style={{ width: `${width}px`, right: rightOffset }}
    >
      <Group className={styles.header} justify="space-between">
        <div>
          <Text fw={600} size="md">
            Security Findings
          </Text>
          {accountName && (
            <Text size="xs" c="dimmed">
              {accountName}
            </Text>
          )}
        </div>
        <ActionIcon variant="subtle" size="sm" onClick={onClose}>
          <FontAwesomeIcon icon={faXmark} />
        </ActionIcon>
      </Group>
      <div className={styles.content}>{children}</div>
    </div>
  );
}
